import axios from 'axios';

// Create an Axios instance
const apiManage = axios.create({
  baseURL: 'https://e-training.ivorytraining.com/api/ar',
});

export default apiManage;
